import { initializeStore } from './store';
import { initializeLocale } from 'UTILS/locales';
import { initializeCallbacks } from 'UTILS/callbacks';

export { defaultTheme } from 'UTILS/theme';
export SelfTest from './SelfTest';
export const selfTestInit = ({
  locale,
  ...otherOptions
}) => {
  initializeLocale({ locale });
  initializeCallbacks({ ...otherOptions });
  initializeStore({ ...otherOptions });
};
